import { Component, Input } from '@angular/core';

import { TranslationKeyMap } from './insight.i18n';
import { MetricThreshold, PerformanceTrend } from './legend.insight.model';

@Component({
    selector: '[cmpsInsightLegend]',
    templateUrl: './legend.insight.component.html',
})
export class LegendInsightComponent {
    @Input() metricThresholds: MetricThreshold[];
    @Input() trends: PerformanceTrend[];
    @Input() showThresholdColours: boolean;
    @Input() showTrendArrows: boolean;

    /** @private */
    _i18n = TranslationKeyMap;
}
